/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import Search from "@material-ui/icons/Search";
import AccountIcon from "@material-ui/icons/AccountBox";
import RegisterUserIcon from "@material-ui/icons/PersonAdd";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';


import DashboardPage from "app/views/Dashboard/Dashboard";
import CustomerOrderEdit from "app/views/CustomerOrderEdit/CustomerOrderEdit.js";
import CustomerOrderSearch from "app/views/CustomerOrderSearch/CustomerOrderSearch.js";
import ShipmentForm from "app/views/ShipmentEdit/ShipmentEdit.js";
import ShipmentSearch from "app/views/ShipmentSearch/ShipmentSearch.js";
import Login from "app/views/Login/login.js";
import UserProfile from "app/views/UserProfile/UserProfile.js";
import RegisterUser from "app/views/UserProfile/RegisterUser.js";
import Logout from "app/views/Logout/logout.js";
import ForgottenPassword from "app/views/UserProfile/ForgottenPassword.js";
import CreateQuote from "app/views/ShipmentQuoteEdit/ShipmentQuoteEdit.js";
import SearchQuote from "app/views/ShipmentQuoteSearch/ShipmentQuoteSearch.js";
import ShipmentDetails from "app/views/ShipmentEdit/ShipmentDetails.js";
import ShipmentQuoteDetails from "app/views/ShipmentQuoteEdit/ShipmentQuoteDetails.js";
import SearchNotification from "app/views/NotificationSearch/NotificationSearch.js";
import CustomerOrderDetails from "app/views/CustomerOrderEdit/CustomerOrderDetails.js";
import NotificationSettings from "app/views/UserProfile/NotificationSettings.js";
import NotFound from 'app/views/NotFound';

const dashboardRoutes = [
    {
        path: "/dashboard",
        name: "Home",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: DashboardPage,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "visible",
        iconbackground: ""
    },
    {
        path: "/createquote",
        name: "Request A Quote",
        rtlName: "ملٝ تعريٝي للمستخدم",
        icon: FactCheckOutlinedIcon,
        component: CreateQuote,
        layout: "/LeoSeaPortal",
        pageTitle: "Create Quote",
        active: "visible",
        iconbackground: "#2059A7"

    },
    {
        path: "/searchquote",
        name: "Search Quote",
        rtlName: "ملٝ تعريٝي للمستخدم",
        icon: Search,
        component: SearchQuote,
        layout: "/LeoSeaPortal",
        pageTitle: "Search Quote",
        active: "visible",
        iconbackground: "#2059A7"

    },
    {
        path: "/createbooking",
        name: "Create Booking",
        rtlName: "طباعة",
        icon: AutoStoriesIcon,
        component: ShipmentForm,
        layout: "/LeoSeaPortal",
        pageTitle: "Create Booking",
        active: "visible",
        iconbackground: "#1DB35A"
    },
    {
        path: "/searchbooking",
        name: "Search Booking",
        rtlName: "الرموز",
        icon: Search,
        component: ShipmentSearch,
        layout: "/LeoSeaPortal",
        pageTitle: "Search Booking",
        active: "visible",
        iconbackground: "#1DB35A"
    },
    {
        path: "/login",
        name: "Login",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: Login,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        exact: true,
        iconbackground: ""
    },
    {
        path: "/userprofile",
        name: "User Profile",
        rtlName: "لوحة القيادة",
        icon: AccountIcon,
        component: UserProfile,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/registeruser",
        name: "Register User",
        rtlName: "لوحة القيادة",
        icon: RegisterUserIcon,
        component: RegisterUser,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/logout",
        name: "Logout",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: Logout,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/forgottenpassword",
        name: "ForgottenPassword",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: ForgottenPassword,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/bookingdetails",
        name: "BookingDetails",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: ShipmentDetails,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/quotedetails",
        name: "QuoteDetails",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: ShipmentQuoteDetails,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/notifications",
        name: "Notifications",
        rtlName: "الرموز",
        icon: NotificationsActiveOutlinedIcon,
        component: SearchNotification,
        layout: "/LeoSeaPortal",
        pageTitle: "Notifications",
        active: "visible",
        iconbackground: "#F78F35"
    },
    {
        path: "/customerorderdetails",
        name: "CustomerOrderDetails",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: CustomerOrderDetails,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/notificationsettings",
        name: "NotificationSettings",
        rtlName: "لوحة القيادة",
        icon: HomeOutlinedIcon,
        component: NotificationSettings,
        layout: "/LeoSeaPortal",
        pageTitle: "",
        active: "hidden",
        iconbackground: ""
    },
    {
        path: "/*",
        name: "NotFound",
        component: NotFound,
        layout: "/LeoSeaPortal",
        active: "hidden",
    }    
];

export default dashboardRoutes;
